import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectSpecialHoursEntities } from 'app/selectors/EntitiesSelector';
import ShortFormattedDate from 'app/components/shared/ShortFormattedDate';
import getActiveHours from 'app/helpers/locations/getActiveHours';
import getUpcomingHours from 'app/helpers/locations/getUpcomingHours';

import './LocationStatus.scss';

function formatTime(time) {
  return moment.utc(time, 'THH:mm').format('h:mm a');
}

export default function LocationStatus({ location }) {
  const specialHoursEntities = useSelector(selectSpecialHoursEntities);
  const specialHours = location.get('specialHoursIds').map(id => specialHoursEntities.get(id));
  const activeHours = getActiveHours(location, specialHours);
  const activeHoursName = activeHours?.get('name');

  function renderHours() {
    if (activeHours?.get('closeTime')) {
      return (
        <FormattedMessage
          id="location_open_status"
          values={{
            closeTime: formatTime(activeHours.get('closeTime')),
            status: (...contents) => <span className="status-open">{contents}</span>
          }}
        />
      );
    }

    const upcomingHours = getUpcomingHours(location, specialHours);
    if (upcomingHours) {
      const upcomingDay = upcomingHours.get('date').format('dddd');
      const upcomingTime = upcomingHours.getIn(['hours', 'openTime']);

      return (
        <FormattedMessage
          id="location_closed_status"
          values={{
            openTime: `${formatTime(upcomingTime)} ${upcomingDay}`,
            status: (...contents) => <span className="status-closed">{contents}</span>
          }}
        />
      );
    }

    if (activeHours?.get('endDate')) {
      return (
        <FormattedMessage
          id="location_closed_status"
          values={{
            openTime: <ShortFormattedDate value={activeHours.get('endDate')} />,
            status: (...contents) => <span className="status-closed">{contents}</span>
          }}
        />
      );
    }

    return (
      <span className="status-closed">
        <FormattedMessage id="closed" />
      </span>
    );
  }

  return (
    <div className="cp-location-status">
      {activeHoursName && <p className="active-hours-name">{activeHoursName}</p>}
      {renderHours()}
    </div>
  );
}

LocationStatus.propTypes = {
  location: ImmutablePropTypes.map.isRequired
};
